import dayjs from 'dayjs'
import { getCurrentInstance, computed } from '@vue/composition-api'
import i18n from '@ms/lang/i18n.js'

export default function useVoucherMixin() {
  const { proxy: vm } = getCurrentInstance()
  const CURRENCY_UNIT = i18n.t('CURRENCY_UNIT')

  const isAppOnly = computed(() => {
    return vm.data.platform && vm.data.platform.toLowerCase() === 'android'
  })

  // 直减红包
  const isCashVoucher = computed(() => {
    return vm.data.type === 1
  })

  const stakeDesc = computed(() => {
    return isCashVoucher.value ? 'No minimum stake' : `${CURRENCY_UNIT} ${vm.data.minStake} minimum stake`
  })

  const diffTime = computed(() => {
    const _time = (vm.data.expireTime - new Date().getTime()) / (24 * 60 * 60 * 1000)
    return Math.ceil(_time)
  })

  const timeDesc = computed(() => {
    const { usableTime, expireTime, status } = vm.data
    // time status === 1 判断差几天 1天/5天/范围
    const start = dayjs(usableTime).format('DD/MM/YYYY')
    const end = dayjs(expireTime).format('DD/MM/YYYY')
    if (status !== 1) {
      return `${start} - ${end}`
    } else {
      return diffTime.value > 1 ? `Expires in ${diffTime.value} Days` : 'Today Only'
    }
  })

  const showAmount = computed(() => {
    const amount = vm.data.amount
    const index = amount.indexOf('.')
    if (index !== -1) {
      // 去掉小数末尾的 0
      return amount.replace(/\.?0*$/, '')
    }
    return amount
  })

  return {
    isAppOnly,
    stakeDesc,
    diffTime,
    timeDesc,
    showAmount
  }
}
